import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "twin-map-instance",
    staticStyle: {
      "height": "100%",
      "width": "100%"
    }
  }, [_c('CoreMapboxMglMap', {
    ref: "twinMap",
    staticClass: "twinMap",
    attrs: {
      "bearing": _vm.realCamera.bearing,
      "zoom": _vm.realCamera.zoom,
      "center": _vm.realCamera.center
    },
    on: {
      "load": _vm.onMapLoaded,
      "moveend": _vm.updateMarkers,
      "zoomend": _vm.updateMarkers
    }
  }, [_vm._l(_vm.polygonValues, function (pValue, i) {
    return _c('MglMarker', {
      key: `pValue_${i}`,
      attrs: {
        "coordinates": pValue.coordinates,
        "dtId": i,
        "offset": {
          x: 0,
          y: 0
        },
        "anchor": "bottom-left"
      }
    }, [_c('span', {
      staticStyle: {
        "z-index": "3"
      },
      attrs: {
        "slot": "marker"
      },
      slot: "marker"
    }, [_c('div', {
      style: `
            background-color: ${pValue.color};
            border-radius: 50px;
            color: black;
            opacity: ${pValue.transparent ? 0.7 : 0.9};
            font-weight: 600;
            height: 40px;
            margin-left: -21px;
            padding: ${pValue.displayIcon ? '4px 10px 10px 10px' : '10px'};
          `
    }, [pValue.displayIcon ? _c(VIcon, {
      staticClass: "markerPin",
      staticStyle: {
        "color": "#fff !important",
        "text-shadow": "none",
        "font-size": "20px",
        "width": "25px"
      },
      attrs: {
        "color": _vm.color
      }
    }, [_vm._v("\n            fal fa-" + _vm._s(pValue.displayIcon) + "\n          ")]) : _vm._e(), !pValue.isBoolVisual ? _c('span', {
      class: pValue.displayIcon ? 'markerPinTitle' : '',
      staticStyle: {
        "font-size": "15px",
        "text-shadow": "none",
        "margin-top": "7px",
        "margin-right": "2px",
        "color": "white"
      }
    }, [_vm._v("\n            " + _vm._s(pValue.value) + "\n          ")]) : _vm._e()], 1), _c('div', {
      staticStyle: {
        "border-left": "3px dotted rgba(255, 255, 255, 0.7)",
        "height": "41px"
      }
    }, [_vm._v(" ")])])]);
  }), _vm._l(_vm.markerItems, function (marker, i) {
    return _c('MglMarker', {
      key: `marker_${i}`,
      attrs: {
        "coordinates": marker.coordinates,
        "title": marker.title,
        "dtId": marker.id,
        "anchor": marker.imageId ? 'center' : 'bottom-left',
        "offset": {
          x: -10,
          y: 0
        }
      },
      on: {
        "click": _vm.markerItemClicked
      }
    }, [_c('span', {
      staticStyle: {
        "z-index": "2"
      },
      attrs: {
        "slot": "marker"
      },
      slot: "marker"
    }, [_vm._t("regularMarker", function () {
      return [marker.imageId ? [_c('div', {
        staticClass: "markerIcon",
        style: `background-image: url('${_vm.mapMarkerIconUrl(marker.imageId)}')`
      })] : [_c(VIcon, {
        staticClass: "markerPin",
        attrs: {
          "color": marker.color || _vm.color
        }
      }, [_vm._v("\n              fal fa-" + _vm._s(marker.faIcon ? marker.faIcon : 'map-marker-alt') + "\n            ")]), _c('span', {
        staticClass: "markerPinTitle",
        style: marker.color ? `color: ${marker.color}` : ''
      }, [_vm._v("\n              " + _vm._s(marker.title) + "\n            ")])]];
    }, {
      "marker": marker
    })], 2)]);
  }), _vm._l(_vm.clusters, function (cluster, i) {
    return _c('MglMarker', {
      key: `cluster_${i}`,
      attrs: {
        "coordinates": cluster.center,
        "title": cluster.count,
        "dtId": `cluster_${i}`,
        "anchor": 'center'
      },
      on: {
        "click": function ($event) {
          return _vm.zoomIntoCluster(cluster);
        }
      }
    }, [_c('span', {
      staticStyle: {
        "z-index": "2"
      },
      attrs: {
        "slot": "marker"
      },
      slot: "marker"
    }, [_c('div', {
      staticClass: "clusterMarker",
      style: `background-color: ${_vm.markerColor}; ${_vm.clusterIconSize(cluster.count)}`
    }, [_vm._v("\n          " + _vm._s(cluster.count) + "\n        ")])])]);
  }), _c('MglNavigationControl', {
    attrs: {
      "position": "bottom-right"
    }
  }), _c('MglGeolocateControl', {
    attrs: {
      "position": "bottom-right"
    }
  })], 2), _vm.selectedMarkerItem.id ? _c('div', {
    staticClass: "twinDetail",
    staticStyle: {
      "z-index": "6"
    }
  }, [_c('core-dtwin-detail', {
    attrs: {
      "dtwin": _vm.selectedMarkerItem,
      "baseLink": _vm.detailsBaseLink,
      "mapmode": ""
    },
    on: {
      "cancel": _vm.closeDtwinPopup
    }
  })], 1) : _vm._e(), _vm._t("bottom"), _vm.selectedCluster.items ? _c('core-n20Card', {
    staticClass: "pb-8 pa-2 dtwin-preview twinClusterDetail",
    staticStyle: {
      "z-index": "6"
    },
    scopedSlots: _vm._u([{
      key: "buttons",
      fn: function () {
        return [_c('core-button', {
          attrs: {
            "title": _vm.$i18n_t('Common.cancel'),
            "color": "danger",
            "prepend-icon": "fa-times"
          },
          on: {
            "click": function ($event) {
              return _vm.$emit('getClusterContent', null);
            }
          }
        })];
      },
      proxy: true
    }], null, false, 489683904)
  }, [_c(VSimpleTable, {
    staticClass: "mt-3 mx-0 pa-0 twinClusterDetailTable",
    scopedSlots: _vm._u([{
      key: "default",
      fn: function () {
        return [_c('tbody', _vm._l(_vm.selectedCluster.items, function (twin, i) {
          return _c('tr', {
            key: `twin_clustered_${i}`
          }, [_c('td', [_c(VIcon, {
            attrs: {
              "color": _vm.color,
              "title": _vm.$i18n_t('Common.viewDetails'),
              "small": ""
            },
            on: {
              "click": function ($event) {
                return _vm.markerItemClicked({
                  ...twin,
                  component: {
                    $attrs: {
                      dtId: twin.id,
                      title: twin.title
                    }
                  }
                });
              }
            }
          }, [_vm._v("\n                fal fa-eye\n              ")])], 1), _c('td', {
            staticStyle: {
              "vertical-align": "middle"
            }
          }, [_c('p', {
            staticClass: "my-0"
          }, [_vm._v(_vm._s(twin.title))])])]);
        }), 0)];
      },
      proxy: true
    }], null, false, 3580520337)
  })], 1) : _vm._e()], 2);
};
var staticRenderFns = [];
export { render, staticRenderFns };